import { Route, Routes, useRoutes } from "react-router-dom";
import routes from "./routes";
import { createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ContactSupport from "./Components/ContactSupport/ContactSupport";
import Header from "./Layout/Header/Header";
import Footer from "./Layout/Footer/Footer";
import NavbarMobile from "./Components/NavbarMobile/NavbarMobile";
import { SearchContext } from "./Hooks/useContext";
import { useState } from "react";
import { CartProvider } from "./Hooks/CartContext";
import { ToastContainer } from "react-toastify";
import Preloader from "./Components/Preloader/Preloader";

function App() {
    const { pathname } = useLocation();
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(true);
    const element = useRoutes(routes);
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        setLoading(true);

        // شبیه‌سازی زمان بارگذاری صفحه
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 1000); // مدت نمایش لودینگ هنگام تغییر مسیر

        return () => clearTimeout(timeout);
    }, [location.pathname]);

    return loading ? (
        <Preloader />
    ) : (
        <>
            <SearchContext.Provider value={{ searchValue, setSearchValue }}>
                <CartProvider>
                    <Header />
                    {element}
                </CartProvider>
            </SearchContext.Provider>
            <ContactSupport />
            <Footer />
            <ToastContainer />
            <NavbarMobile />
        </>
    );
}

export default App;
